export default __webpack_public_path__ + "static/media/info-centre.b62738b7.webp";